'use client'

import { useEffect } from 'react'

import { Action } from '@/ui/components/ui/action'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Erreur détectée:', error)
  }, [error])

  return (
    <section className="flex min-h-screen items-center bg-paper">
      <div className="shell">
        <p className="annot mb-6 text-signal-deep">Erreur</p>
        <h1 className="max-w-[16ch]">Oups ! Une erreur est survenue.</h1>
        <p className="mt-8 max-w-[60ch] text-lg text-anthracite">
          Il semble qu&apos;un problème soit survenu. Vous pouvez essayer de
          recharger la page ou revenir à l&apos;accueil.
        </p>
        <div className="mt-12 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => reset()}
            className="group inline-flex items-center gap-3 rounded-[3px] bg-ink px-7 py-4 font-mono text-[0.6875rem] uppercase tracking-[0.16em] text-chalk transition-colors duration-300 hover:bg-anthracite"
          >
            Réessayer
          </button>
          <Action href="/" variant="outline">
            Retour à l&apos;accueil
          </Action>
        </div>
      </div>
    </section>
  )
}
